import { ShieldAlert } from "lucide-react";

import { FactsToConfirm } from "@/components/draft/facts-to-confirm";
import { useConversationSession } from "@/hooks/use-conversation-session";

export function ComposerText({
	personId,
	sendDisabled,
	onSend,
}: {
	personId: number;
	sendDisabled: boolean;
	onSend: () => void;
}) {
	const { session, draft } = useConversationSession(personId);
	const mode = draft.images.length > 0 ? "caption" : "response";
	const copy = {
		caption: { label: "Legenda das imagens", placeholder: "Adicionar legenda...", maxLength: 1024 },
		response: { label: "Resposta", placeholder: "Escreva uma resposta...", maxLength: undefined },
	}[mode];

	return (
		<>
			<textarea
				data-slot="composer-text"
				aria-label={copy.label}
				value={draft.text}
				onChange={(event) => session.editText(event.target.value)}
				onKeyDown={(event) => {
					if ((event.metaKey || event.ctrlKey) && event.key === "Enter" && !sendDisabled) {
						event.preventDefault();
						onSend();
					}
				}}
				placeholder={copy.placeholder}
				maxLength={copy.maxLength}
				rows={2}
				className="max-h-40 min-h-20 w-full resize-none bg-transparent px-3 py-3 text-base leading-relaxed [field-sizing:content] focus-visible:outline-none md:text-sm"
			/>
			{draft.suggestion?.neutral && (
				<p className="flex items-center gap-2 px-3 pb-2 text-xs text-warning">
					<ShieldAlert className="size-4" />
					Sugestão sem dados clínicos nominais
				</p>
			)}
			{!!draft.suggestion?.facts_to_confirm.length && (
				<div className="px-3 pb-2">
					<FactsToConfirm facts={draft.suggestion.facts_to_confirm} />
				</div>
			)}
		</>
	);
}
